define('lib/jquery/jquery.dateInput',['require','jquery','underscore','moment','translate'],function(require) {
  const $ = require('jquery');
  const _ = require('underscore');
  const moment = require('moment');
  const t = require('translate');

  const CLASS_NAME = 'date-input';
  const INVALID_CLASS_NAME = 'invalid-date-input';
  const DATE_FORMAT = 'YYYY-MM-DD';
  const PLACEHOLDER = 'YYYY-MM-DD';
  const MIN_DATE_OPTION = 'minDate';
  const MIN_DATE_ATTRIBUTE = 'data-min-date';
  const DATE_SEPARATOR = '-';
  const DAY_AND_MONTH_LONG_FORMAT_PREFIX = '0';
  const DAY_AND_MONTH_TARGET_LENGTH = 2;

  $.fn.dateInput = function(methodOrOptions) {
    const settings = $.extend({
      minDate: null,
      onChange: null,
    }, methodOrOptions || {});

    settings.placeholder = t(`${PLACEHOLDER} #locale`);

    const methods = {
      reset: function() {
        this.val('')
        this.removeClass(INVALID_CLASS_NAME);
      },
      setDate: function(date) {
        let dateText = '';

        if (date instanceof Date) {
          dateText = moment(date).format(DATE_FORMAT);
        } else if (typeof date === 'string') {
          dateText = date;
        }

        this.val(dateText)
        this.removeClass(INVALID_CLASS_NAME);
      },
      option: function(option, value) {
        if (option === MIN_DATE_OPTION) {
          const minDate = value instanceof Date ? moment(value).format(DATE_FORMAT) : null;

          this.attr(MIN_DATE_ATTRIBUTE, minDate);
        }
      }
    };

    if (!methodOrOptions || typeof methodOrOptions === 'object') {
      this.each(function() {
        $.dateInput(this, settings);
      });
    } else if (methods[methodOrOptions]) {
      return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
    }
  };

  $.dateInput = function(element, settings) {
    const DATE_FORMAT_REGEX = /^\d{4}-\d{1,2}-\d{1,2}$/;
    const PARTIAL_DATE_FORMAT_REGEX = /^\d{1,4}(-\d{0,2})?(-\d{0,2})?$/;
    const ENTER_KEY = 'Enter';

    const $input = $(element);

    let lastValidValue = '';
    let isDirty = false;

    const tryGetLongFormattedDate = (value) => {
      let formattedValue = value;

      if (value && DATE_FORMAT_REGEX.test(value)) {
        const [year, month, day] = value.split(DATE_SEPARATOR);
        const formattedMonth = month.padStart(DAY_AND_MONTH_TARGET_LENGTH, DAY_AND_MONTH_LONG_FORMAT_PREFIX);
        const formattedDay = day.padStart(DAY_AND_MONTH_TARGET_LENGTH, DAY_AND_MONTH_LONG_FORMAT_PREFIX);

        formattedValue = `${year}${DATE_SEPARATOR}${formattedMonth}${DATE_SEPARATOR}${formattedDay}`;
      }

      return formattedValue
    };

    const parseDate = (value) => {
      const formattedValue = tryGetLongFormattedDate(value || '');
      const date = Date.parse(formattedValue);

      return !isNaN(date) ? moment(formattedValue) : undefined;
    };
  
    const checkIsValidDate = (value) => {
      const isValidFormat = DATE_FORMAT_REGEX.test(value);
      const date = parseDate(value);
      const minDate = parseDate($input.attr(MIN_DATE_ATTRIBUTE));

      let isValidDate = isValidFormat && !!date;

      if (isValidDate && minDate) {
        isValidDate = date >= minDate;
      }

      return isValidDate;
    };

    const checkIsValidPartialDate = (value) => (value ? PARTIAL_DATE_FORMAT_REGEX.test(value) : true);

    const handleInput = (e) => {
      const { target } = e;
      const { value } = target;

      const isValidPartialDate = checkIsValidPartialDate(value);

      if (isValidPartialDate) {
        lastValidValue = value;

        isDirty = true;
        $input.removeClass(INVALID_CLASS_NAME);
      } else {
        target.value = lastValidValue;
      }
    };

    const handleKeyDown = (e) => {
      const { key, target } = e;

      if (key === ENTER_KEY) {
        target.blur();
      }
    };

    const reportChange = (e) => {
      if (isDirty) {
        const { value } = e.target;
        const isValidDate = checkIsValidDate(value);

        if (_.isFunction(settings.onChange) && isValidDate) {
          const formattedDate = tryGetLongFormattedDate(value);

          settings.onChange(formattedDate, $input);
        } else if (!isValidDate) {
          $input.addClass(INVALID_CLASS_NAME);
        }
  
        isDirty = false;
      }
    };

    $input
      .addClass(CLASS_NAME)
      .attr('type', 'text')
      .attr('placeholder', settings.placeholder)
      .attr('title', settings.placeholder)
      .attr('maxlength', DATE_FORMAT.length)

    $input
      .on('input', handleInput)
      .on('keydown', handleKeyDown)
      .on('blur', reportChange);
  };
});

